import React from 'react';
import { LanguageProvider } from '../contexts/LanguageContext';
import Navbar from '../components/canva/Navbar';
import HeroSection from '../components/canva/HeroSection';
import ProblemSection from '../components/canva/ProblemSection';
import SolutionSection from '../components/canva/SolutionSection';
import WorkflowSection from '../components/canva/WorkflowSection';
import AISection from '../components/canva/AISection';
import TechnicalSection from '../components/canva/TechnicalSection';
import ConclusionSection from '../components/canva/ConclusionSection';

const CanvaPage = () => {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        {/* Fixed Navigation Bar */}
        <Navbar />
        
        {/* Main Content - Scroll Sections */}
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <WorkflowSection />
        <AISection />
        <TechnicalSection />
        <ConclusionSection />
      </div>
    </LanguageProvider>
  );
};

export default CanvaPage;
